import ContactsContent from './components/contacts-content';

import './index.css';

const Contacts = () => {
  return (
    <main className="Product__main">
      <ContactsContent />
    </main>
  );
};

export default Contacts;
